import { Button } from "@/design-system/Button/Button";
import { useTranslation } from "@repo/shared/i18n";

/** Opens a player reward's page, under the card on the set page. */
export const ViewRewardButton = ({ onClick }: { onClick: () => void }) => {
  const { t } = useTranslation("sbcs");

  return (
    <Button
      variant="secondary"
      size="small"
      className="relative z-10 mx-auto -mt-2 h-6 px-2.5 text-xs"
      onClick={onClick}
    >
      {t("set.viewReward")}
    </Button>
  );
};
